import '../../style/index.css';

// style dependencies
// deps-lint-skip: grid
import '../../grid/style/css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/col/style/css.js
// module id = PTeY
// module chunks = 25